import { CHROMATIC, GREY, colorTokens } from './tokens';

// ----------------------------------------------------------------------
// The MUI palette, built from the Cabinet Base tokens (tokens.js). Values are
// not chosen here — only mapped into the shape MUI and our components read.
//
// Beyond MUI's own keys every chromatic colour carries:
//   soft / softText  <Label variant="soft"> fill and its text
//   hover            (primary only) contained-button hover fill
//   tint6/12/18, border  (primary only) highlighted toolbar controls
// ----------------------------------------------------------------------

const chromatic = (t, color) => ({
    lighter: t[`${color}-lighter`],
    light: t[`${color}-light`],
    main: t[`${color}-main`],
    dark: t[`${color}-dark`],
    darker: t[`${color}-darker`],
    contrastText: t[`on-${color}`],
    soft: t[`${color}-soft`],
    softText: t[`${color}-soft-text`]
});

export function createPalette(mode = 'light') {
    const t = colorTokens(mode);

    const colors = Object.fromEntries(
        CHROMATIC.map((color) => [color, chromatic(t, color)])
    );
    Object.assign(colors.primary, {
        hover: t['primary-hover'],
        tint6: t['primary-tint-6'],
        tint12: t['primary-tint-12'],
        tint18: t['primary-tint-18'],
        border: t['primary-border']
    });

    return {
        mode,
        common: { black: t['common-black'], white: t['common-white'] },
        ...colors,
        grey: GREY,
        divider: t.divider,
        text: {
            primary: t['text-primary'],
            secondary: t['text-secondary'],
            placeholder: t['text-placeholder'],
            disabled: t['text-disabled'],
            success: t['text-success'],
            error: t['text-error']
        },
        background: {
            paper: t['background-paper'],
            default: t['background-default'],
            neutral: t['background-neutral'],
            tooltip: t['background-tooltip']
        },
        border: {
            input: t['border-input'],
            underline: t['border-underline']
        },
        fill: { input: t['fill-input'] },
        focus: { ring: t['primary-main'], halo: t['focus-halo'] },
        backdrop: t.backdrop,
        count: {
            background: t['count-background'],
            text: t['count-text'],
            zeroBorder: t['count-zero-border'],
            zeroText: t['count-zero-text']
        },
        action: {
            active: t['action-active'],
            hover: t['action-hover'],
            selected: t['action-selected'],
            disabled: t['action-disabled'],
            disabledBackground: t['action-disabled-background'],
            focus: t['action-focus'],
            hoverOpacity: 0.08,
            disabledOpacity: 0.48
        }
    };
}

const palette = createPalette('light');

export default palette;
